import React, {useEffect, useState} from 'react';
import {AppLinkPreview, InternalPageRoot, PdfOrImgViewer} from "../../../index";
import {useTheme} from "../../../../common/ProjectThemeProvider";
import {checkNullStr, getCurrUrlMainDomain, getCurrUrlParamValue, getJsonValue, isBoolTrue, isJsonValueTrue} from "../../../../common/fusion-ui/utils/ReactUtils";
import {formatDateValue, formatDurationToReadable, getAllocatedModuleName, printError, printLog, sendRequest} from "../../../utils/AppUtils";
import {useToast} from "../../../../common/fusion-ui/provider/ToastProvider";
import {Anchor, Avatar, Flexbox, Section} from "../../../../common/fusion-ui";
import {GenRouteUrls, Keys, ModuleFieldsData, Modules, ReqUrls, ShareFeatureModules, ShowViewType} from "../../../config/AppConfig";
import {DefStrNA, Messages} from 'common/fusion-ui/config/FusionConfig';
import {CssVariant} from '../../../../common/fusion-ui/config/FusionConfig';
import {useConfig} from "../../../context/ConfigProvider";

const Wm_InternalPage = React.memo(({
                                        open, onHide, recordId, showAs = ShowViewType.PAGE,
                                    }) => {
    const TAG = "Wm_InternalPage";

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isConfigTrue, updateConfig} = useConfig();

    const moduleName = Modules.WebMeeting;
    const mf = ModuleFieldsData[moduleName];

    const Fields = {
        recordId: 'recordId', pageDataObject: 'pageDataObject',

        isDataLoading: 'isDataLoading', isDataFound: 'isDataFound', dataLoadingMsg: 'dataLoadingMsg', isDataFetched: 'isDataFetched',

        prevRecordId: 'prevRecordId', nextRecordId: 'nextRecordId',
    };

    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        // log('useEffect.showAs:', showAs, 'recordId:', recordId);
        if (showAs == ShowViewType.PAGE) {
            const id = getCurrUrlParamValue('id');
            fetchPageData(id, true);
        } else {
            if (checkNullStr(recordId)) {
                fetchPageData(recordId, false);
            }
        }
    }, [recordId, showAs]);

    return (<>
        <InternalPageRoot
            tag={TAG}
            moduleName={moduleName}
            title={`${getAllocatedModuleName(moduleName)} Details`}
            backToListText={`Back to ${getAllocatedModuleName(moduleName).toLowerCase()}`}
            isDataFound={getField(Fields.isDataFound)}
            isDataLoading={getField(Fields.isDataLoading)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            internalPageUrl={GenRouteUrls.wm_internalPage}
            prevRecordId={getField(Fields.prevRecordId)}
            nextRecordId={getField(Fields.nextRecordId)}
            onPrev={() => fetchPageData(getField(Fields.prevRecordId), false)}
            onNext={() => fetchPageData(getField(Fields.nextRecordId), false)}
            showShare={ShareFeatureModules.some((item) => item.tag == TAG)}
            shareUrl={`${getCurrUrlMainDomain()}${GenRouteUrls.wm_internalPage}${getField(Fields.recordId)}`}
            open={open}
            onHide={onHide}
            showAs={showAs}>
            <div>
                <table className={'w-100x'} style={{color: theme.text}}>
                    <tbody>
                    {/* Updated by Vandit Tewari on (29/10/24) - in every tr given a class 'wmInternalPageTrBreak' done this bcz below 560px the text in some td getting out of screen as these both comes in same row - declared in fusion css text-break*/}
                    {/*title*/}
                    <tr className={'wmInternalPageTrBreak'}>
                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.title.titleAlt2}:</th>
                        <td className={'px-2 text-wrap text-break'}>{getPageField(mf.title, DefStrNA)}</td>
                    </tr>

                    {/*outline*/}
                    <tr className={'wmInternalPageTrBreak'}>
                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.outline.titleAlt2}:</th>
                        <td className={'px-2 text-wrap text-break'}>{getPageField(mf.outline, DefStrNA)}</td>
                    </tr>

                    {/*desc*/}
                    <tr className={'wmInternalPageTrBreak'}>
                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.desc.titleAlt}:</th>
                        <td className={'px-2 text-break'}>
                            <div className={'text-wrap'}
                                 dangerouslySetInnerHTML={{__html: getPageField(mf.desc, DefStrNA)}}/>
                        </td>
                    </tr>

                    {/*date*/}
                    <tr className={'wmInternalPageTrBreak'}>
                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.date.titleAlt2}:</th>
                        <td className={'px-2 text-wrap text-break'}>{formatDateValue(getPageField(mf.date, DefStrNA))}</td>
                    </tr>

                    {/*duration*/}
                    <tr className={'wmInternalPageTrBreak'}>
                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.duration.title}:</th>
                        <td className={'px-2 text-wrap text-break'}>{formatDurationToReadable(getPageField(mf.duration), DefStrNA)}</td>
                    </tr>

                    {/*newPresenterBio*/}
                    <tr className={'wmInternalPageTrBreak'}>
                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.newPresenterBio.titleAlt}:</th>
                        <td className={'px-2 text-wrap text-break'}>
                            {/*Bio*/}
                            {checkNullStr(getPageField(mf.newPresenterBio)) && <div className={'text-wrap fw-bold'}>{getPageField(mf.newPresenterBio)}</div>}

                            {/* Presenter Bio */}
                            <div className={''}>
                                {/*presenter*/}
                                {/*{checkNullStr(getPageField(mf.presenter)) &&*/}
                                {/*    <div>{getPageField(mf.presenter)}</div>}*/}

                                {/*Qualification*/}
                                {checkNullStr(getPageField(mf.newPresenterQualification)) &&
                                    <div className={'text-wrap'}>{getPageField(mf.newPresenterQualification)}</div>}

                                {/*designation*/}
                                {checkNullStr(getPageField(mf.newPresenterBio)) && <div className={'text-wrap'}>{getPageField(mf.newPresenterBio)}</div>}

                                {/*Org*/}
                                {checkNullStr(getPageField(mf.newPresenterOrg)) && <div className={'text-wrap'}>{getPageField(mf.newPresenterOrg)}</div>}
                            </div>
                        </td>
                    </tr>

                    {/*link*/}
                    <tr className={'wmInternalPageTrBreak'}>
                        <th className={'text-nowrap flex-nowrap d-flex al-start jc-start'}>{mf.link.titleAlt}:</th>
                        <td className={'px-2 text-wrap text-break'}>
                            {checkNullStr(getPageField(mf.link)) ? (<div className={''}>
                                <Anchor
                                    href={getPageField(mf.link)}
                                    simple={true}
                                    target={'blank'}>Click Here To Join Meeting </Anchor>
                            </div>) : (<span>{DefStrNA}</span>)}
                        </td>
                    </tr>
                    </tbody>
                </table>

                {/*link-preview*/}
                <div className={'mt-2 wmInternalPageTrBreak'}>
                    <AppLinkPreview url={getPageField(mf.link)}/>
                </div>

                {/* presenter-card */}
                <div className={'d-flex w-auto mt-3'}>
                    <Section
                        className={'h-auto px-2'}
                        borderColor={theme.text30}>
                        <Flexbox justifyAt={'start'} alignAt={'center'}>
                            <div>
                                <Avatar
                                    circular={false}
                                    size={'90px'}
                                    imgClassName={'rounded-4'}
                                    wrapperClassName={' me-1'}
                                    className={''}>
                                    {getPageField(mf.newPresenterImage)}
                                </Avatar>
                            </div>
                            {/* Presenter Bio */}
                            <div className={'ms-2'}>
                                {/*presenter*/}
                                {checkNullStr(getPageField(mf.presenter)) && <div className={'fw-semi-bold'}>{getPageField(mf.presenter)}</div>}

                                {/*Qualification*/}
                                {checkNullStr(getPageField(mf.newPresenterQualification)) && <div>{getPageField(mf.newPresenterQualification)}</div>}

                                {/*designation*/}
                                {checkNullStr(getPageField(mf.newPresenterDesignation)) && <div>{getPageField(mf.newPresenterDesignation)}</div>}

                                {/*Org*/}
                                {checkNullStr(getPageField(mf.newPresenterOrg)) && <div>{getPageField(mf.newPresenterOrg)}</div>}
                            </div>
                        </Flexbox>
                    </Section>
                </div>

                {/* Document viewer */}
                <div className={'my-3'}>

                    {/*pdf*/}
                    <div className={'mt-3x'}>
                        <PdfOrImgViewer
                            src={getPageField(mf.doc)}
                            fileExt={getPageField(mf.docFileExt)}
                        />
                    </div>
                </div>
            </div>
        </InternalPageRoot>
    </>)

    //======================Request Functions start=====================
    async function fetchPageData(recordId, checkBefore = true) {
        const fun = 'fetchPageData:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isDataFetched))) {
            // log(fun, 'recordId:', recordId);
            updateField(Fields.isDataFetched, true);
            updateField(Fields.recordId, recordId);
            if (checkNullStr(recordId)) {
                updateField(Fields.pageDataObject, {});
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, true);
                updateField(Fields.dataLoadingMsg, "");
                updateField(Fields.nextRecordId, null);
                updateField(Fields.prevRecordId, null);

                const REQUEST_OPTIONS = {
                    recordId: recordId, getAdjacentRecordIds: true,
                };

                try {
                    sendRequest({
                        reqUrl: ReqUrls.wm__addEditPage_fetch_editFormData,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            // log(fun, 'fetchedData:', fetchedData);

                            const fetchedPageData = getJsonValue(fetchedData, 'data', {});
                            const success = isJsonValueTrue(fetchedData, 'success');
                            const message = getJsonValue(fetchedData, 'message');

                            if (success) {
                                // toast(message, CssVariant.success)
                                updateField(Fields.pageDataObject, fetchedPageData);
                                updateConfig(Keys.sharePanel_recordTitle, getJsonValue(fetchedPageData, mf.title.column));
                                updateConfig(Keys.sharePanel_recordDescription, getJsonValue(fetchedPageData, mf.outline.column));

                                updateField(Fields.nextRecordId, getJsonValue(fetchedPageData, 'nextRecordId'));
                                updateField(Fields.prevRecordId, getJsonValue(fetchedPageData, 'prevRecordId'));
                            } else {
                                toast(message, CssVariant.danger)
                                updateField(Fields.dataLoadingMsg, message);
                            }
                            updateField(Fields.isDataFound, success);
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            toast(Messages.fetchError, CssVariant.danger)
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } catch (error) {
                    toast(Messages.fetchError, CssVariant.danger)
                    logErr(fun, error);
                    updateField(Fields.dataLoadingMsg, Messages.fetchError);
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            } else {
                toast('Record-id not found!', CssVariant.danger);
                updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                updateField(Fields.isDataFound, false);
                updateField(Fields.isDataLoading, false);
            }
        }
    }

    //======================Request Functions end=====================

    //======================Util Functions start=====================
    function getPageField(colField, defValue) {
        return getJsonValue(getField(Fields.pageDataObject), colField.column, defValue);
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default Wm_InternalPage;
